import PagePointage from "@features/pointage/components/PagePointage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/auth/pointage/$hash")({
  component: PagePointage,
});
